/* Source: /home/sidsolaiyappan/skooch_ai/shared/preview_flags.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function shouldEnablePreview(search, lsValue) {
  let _s = String((search || ""));
  if (_s.includes("preview=new")) {
    return true;
  }
  if ((lsValue === "1")) {
    return true;
  }
  return false;
}
function applyPreviewFlags() {
  let _search = "";
  let _ls = null;
  try {
    _search = String((window.location.search || ""));
  } catch (__jac_e) {
    if (true) {
      let _sErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    _ls = localStorage.getItem("skooch_preview");
  } catch (__jac_e) {
    if (true) {
      let _lsErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  if (!shouldEnablePreview(_search, _ls)) {
    return;
  }
  try {
    window.__skoochNewLanding = true;
  } catch (__jac_e) {
    if (true) {
      let _nlErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    window.__skoochNewPriorityUI = true;
  } catch (__jac_e) {
    if (true) {
      let _npErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
  try {
    localStorage.setItem("skooch_preview", "1");
  } catch (__jac_e) {
    if (true) {
      let _setErr = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
export {applyPreviewFlags, shouldEnablePreview};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:shouldEnablePreview": {"is_writer": false, "touches": ["*"]}, "func:applyPreviewFlags": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=preview_flags.js.map
